var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9322 18.8172C22.9322 21.4387 20.8069 23.564 18.1853 23.564C15.5638 23.564 13.4385 21.4387 13.4385 18.8172C13.4385 16.1956 15.5638 14.0703 18.1853 14.0703C20.8069 14.0703 22.9322 16.1956 22.9322 18.8172Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7893 11.1646H25.0792C24.727 11.1646 24.3974 10.9882 24.2016 10.6951L22.7183 8.4699C22.5225 8.17578 22.193 8 21.8404 8H14.5306C14.1785 8 13.8488 8.17619 13.653 8.4699L12.1697 10.6951C11.9739 10.9882 11.6444 11.1646 11.2918 11.1646H6.5822C5.70822 11.1646 5 11.8735 5 12.7468V25.9327C5 26.8064 5.70822 27.5146 6.5822 27.5146H29.7893C30.6633 27.5146 31.3715 26.8064 31.3715 25.9327V12.7468C31.3717 11.8735 30.6635 11.1646 29.7895 11.1646H29.7893ZM18.1857 25.1458C14.6955 25.1458 11.8565 22.307 11.8565 18.8166C11.8565 15.3276 14.6956 12.4874 18.1857 12.4874C21.6759 12.4874 24.5149 15.3276 24.5149 18.8166C24.5149 22.3068 21.6759 25.1458 18.1857 25.1458ZM26.0972 13.5485C26.0972 13.8369 25.8636 14.0697 25.575 14.0697H25.5644C25.276 14.0697 25.042 13.8367 25.042 13.5485V13.5375C25.042 13.2491 25.2758 13.0153 25.5644 13.0153H25.575C25.8634 13.0153 26.0972 13.2491 26.0972 13.5375V13.5485Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16406 9.05469H10.2738V10.1098H8.16406V9.05469Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.8d6d675c2d65ffdbe1a65a5fe794649a.svg";
export { ForwardRef as ReactComponent };